<template>
    <div id="item-detail-page">

        <vx-card v-if="foodItem" >
            <template slot="no-body">

                <div class="item-content">

                    <!-- Item Main Info -->
                    <div class="product-details p-6">
                        <div class="vx-row mt-6">
                            <div class="vx-col md:w-2/5 w-full flex items-center justify-center ">
                                <div class="product-img-container w-11/12 mx-auto mb-10 md:mb-0">
                                    <img v-if="foodItem.image_name.length > 0" :src="'/api/listing/v1/foodImage/' + foodItem.image_name" :alt="foodItem.name" class="responsive">

                                    <!--
                                      UnComment Below line for true flow
                                      <img :src="item_data.image" :alt="item_data.name" class="responsive">

                                      Remove above img tag which is for demo purpose in actual flow
                                    -->
                                </div>
                            </div>

                            <!-- Item Content -->
                            <div class="vx-col md:w-3/5 w-full">

                                <h3>{{ foodItem.name }}</h3>
                                <p class="flex items-center flex-wrap">
                                    <span class="text-2xl leading-none font-medium text-primary mr-4 mt-2">{{ price }}&euro;</span>
                                </p>

                                <vs-divider />

                                <p style="white-space: pre-wrap">{{ foodItem.description }}</p>

                                <vs-divider />

                                <div :key="index" v-for="(option, index) in options">
                                    <div class="vx-row">
                                        <div class="vx-col w-full">
                                            <span class="text-xl font-medium">{{option.name}}</span>
                                            <div class="flex flex-wrap items-center mt-2">
                                                <ul style="display: flex; flex-wrap: wrap; justify-content: flex-start; align-items: center;">
                                                    <li class="mr-4" :key="index" v-for="(item, index) in option.items">
                                                        <vs-radio :vs-name="option.name" v-model="selectedOptions[option.id]" :vs-value="item">{{item.item_name}}</vs-radio>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <vs-divider />
                                </div>

                                <!-- Quantity -->
                                <div class="vx-row">

                                    <!--<div class="vx-col w-full">
                                        <p class="my-2">
                                            <span>Available</span>
                                            <span class="mx-2">-</span>
                                            <span class="text-success">In Stock</span>
                                        </p>
                                    </div>-->

                                    <div class="vx-col w-full">
                                        <div class="flex flex-wrap items-start mb-4">

                                            <!-- Add To Cart Button -->
                                            <vs-button
                                                    class="mr-4 mb-4"
                                                    icon-pack="feather"
                                                    icon="icon-shopping-cart"
                                                    v-if="$store.state.loggedIn"
                                                    :disabled="Object.values(selectedOptions).length !== options.length"
                                                    @click="addToCart">
                                                Dodaj v voziček
                                            </vs-button>
                                            <!-- /Add To Cart Button -->

                                            <vs-button v-if="$store.state.companyAdmin" @click="foodEditPromptActive = true">Uredi jed</vs-button>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>

            </template>
        </vx-card>

        <options-table v-if="$store.state.companyAdmin" :base-u-r-l="'/api/management/v1/food/' + $route.params.id"/>
        <additions-table v-if="$store.state.companyAdmin" :base-u-r-l="'/api/management/v1/food/' + $route.params.id"/>

        <vs-popup title="Uredi jed" :active.sync="foodEditPromptActive">
            <div>
                <p class="mt-6">Ime</p>
                <vs-input v-model="foodEditName" style="width: 100%"></vs-input>
                <p class="mt-6">Cena</p>
                <vs-input v-model="foodEditPrice" style="width: 100%"></vs-input>
                <vs-checkbox class="mt-6" v-model="foodEditAdditionChangePossible">Dovoljena zamenjava dodatkov</vs-checkbox>
                <p class="mt-6">Opis</p>
                <vs-textarea v-model="foodEditDescription" class="mt-3 w-full" />
                <p class="mt-6">Vključeni dodatki</p>
                <vs-table noDataText="Ni dodatkov" ref="table" v-model="selectedIncludedAdditions" multiple pagination search :max-items="50" :data="additions">

                    <template slot="thead">
                        <vs-th sort-key="name">Ime</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <tbody>
                        <vs-tr :data="tr.id" :key="index" v-for="(tr, index) in data">

                            <vs-td :data="data[index].name">
                                {{ data[index].name }}
                            </vs-td>

                        </vs-tr>
                        </tbody>
                    </template>

                </vs-table>
                <vs-upload text="Spremeni sliko" :automatic="true" limit="1" fileName="file" :action="'/api/management/v1/food/' + $route.params.id + '/image'" @on-success="updateFoodItem" />

                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="editFood">Shrani</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>

    import OptionsTable from "./OptionsTable";
    import AdditionsTable from "./AdditionsTable";
    export default {
        components: {AdditionsTable, OptionsTable},
        data(){
            return {
                foodItem: null,
                options: [],

                additions: [],

                selectedOptions: {},

                foodEditPromptActive: false,

                foodEditName: '',
                foodEditPrice: 0,
                foodEditDescription: '',
                foodEditAdditionChangePossible: false,

                foodEditSelectedAdditions:'',
                selectedIncludedAdditions: []
            }
        },
        methods: {
            updateFoodItem(){
                const thisIns = this;
                this.updateFoodOptions();
                this.updateFoodAdditions();
                this.$http.get('/api/listing/v1/food/' + this.$route.params.id)
                    .then(function (response) {
                        thisIns.foodItem = response.data;

                        thisIns.foodEditName = thisIns.foodItem.name;
                        thisIns.foodEditPrice = thisIns.foodItem.price;
                        thisIns.foodEditDescription = thisIns.foodItem.description;
                        thisIns.foodEditAdditionChangePossible = thisIns.foodItem.addition_change_possible;
                        thisIns.selectedIncludedAdditions = thisIns.foodItem.included_additions;

                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            updateFoodOptions(){
                const thisIns = this;
                this.$http.get('/api/listing/v1/food/' + this.$route.params.id + "/option")
                    .then(function (response) {
                        thisIns.options = response.data;
                        for(let x = 0; x < thisIns.options; x++){
                            thisIns.selectedOptions[thisIns.options[x].id] = thisIns.options[x].items[0];
                        }
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            updateFoodAdditions(){
                const thisIns = this;
                this.$http.get('/api/listing/v1/food/' + this.$route.params.id + "/addition")
                    .then(function (response) {
                        thisIns.additions = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            editFood(){

                const thisIns = this;
                this.$http.put('/api/management/v1/food/' + this.$route.params.id, {
                    name: this.foodEditName,
                    description: this.foodEditDescription,
                    price: Number(this.foodEditPrice),
                    addition_change_possible: this.foodEditAdditionChangePossible,
                    included_additions: this.selectedIncludedAdditions,
                }).then(function () {
                    thisIns.foodEditPromptActive = false;
                    thisIns.updateFoodItem()
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            addToCart(){
                this.$vs.loading();
                const thisIns = this;

                let options = {};

                for (let key in this.selectedOptions) {
                    if (this.selectedOptions.hasOwnProperty(key)){
                        options[key] = this.selectedOptions[key].id
                    }
                }

                this.$http.post('/api/order/v1/food/' + this.$route.params.id, {
                    options: options,
                }).then(function () {
                    thisIns.$vs.loading.close();
                    thisIns.$router.push("/cart");
                }).catch(function (error) {
                    thisIns.$vs.loading.close();
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        computed: {
          price(){

              let startPrice = this.foodItem.price;

              for (let key in this.selectedOptions) {
                  if (this.selectedOptions.hasOwnProperty(key)){
                      if(this.selectedOptions[key].price_change_type === 2 && !this.selectedOptions[key].change_on_end){
                          startPrice *= this.selectedOptions[key].change
                      }
                  }
              }

              for (let key in this.selectedOptions) {
                  if (this.selectedOptions.hasOwnProperty(key)){
                      if(this.selectedOptions[key].price_change_type === 1){
                          startPrice += this.selectedOptions[key].change
                      }
                  }
              }

              for (let key in this.selectedOptions) {
                  if (this.selectedOptions.hasOwnProperty(key)){
                      if(this.selectedOptions[key].price_change_type === 2 && this.selectedOptions[key].change_on_end){
                          startPrice *= this.selectedOptions[key].change
                      }
                  }
              }

              startPrice = Math.round(startPrice*100)/100;

              return startPrice;


          }
        },
        created() {
            this.updateFoodItem();
        }
    }
</script>

<style lang="scss">

    @import "@/assets/scss/vuexy/_variables.scss";

#item-detail-page {
.color-radio {
        height: 2.28rem;
        width: 2.28rem;

    > div {
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

.item-features {
        background-color: #f7f7f7;

    .theme-dark & {
            background-color: $theme-dark-secondary-bg;
    }
    }

.product-sales-meta-list {
    .vs-list--icon {
            padding-left: 0;
        }
    }

.related-product-swiper {
        // padding-right: 2rem;
        // padding-left: 2rem;

    .swiper-wrapper {
            padding-bottom: 2rem;

        > .swiper-slide {
                background-color: #f7f7f7;
                box-shadow: 0 4px 18px 0 rgba(0,0,0,0.1), 0 5px 12px 0 rgba(0,0,0,0.08) !important;

            .theme-dark & {
                    background-color: $theme-light-dark-bg;
            }
            }
        }

    .swiper-button-next,
    .swiper-button-prev {
            transform: scale(.5);
            filter: hue-rotate(40deg);
        }

    .swiper-button-next {
            right: 0
        }

    .swiper-button-prev {
            left: 0;
        }
    }
}
</style>
